import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneWebComponentsAngularModule } from '@one/angular';
import { NotificationSearchComponent } from '../notification-search/notification-search.component';
import { NotificationRecipientsTableComponent } from '../notification-recipients-table/notification-recipients-table.component';
import { recepientTableColumns, recepientTableInit } from '../../constants';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { FilterOverlayDialogComponent } from '../filter-overlay-dialog/filter-overlay-dialog.component';
import { FormsModule } from '@angular/forms';
import { NotificationSearchService } from '../notification-search/notification-search.service';

@Component({
  selector: 'dl-contact-table',
   standalone: true,
  imports: [CommonModule, OneWebComponentsAngularModule,FilterOverlayDialogComponent,FormsModule,NotificationRecipientsTableComponent,NotificationSearchComponent],
  templateUrl: './contact-table.component.html',
  styleUrl: './contact-table.component.scss'
})
export class ContactTableComponent {
  @ViewChild('exporter', { static: true }) exporter: ElementRef;
  @ViewChild('settingsIcon', { read: ElementRef }) settingsIconRef: ElementRef;
  public menuVisible = false;
  public contactDataObj: any = [];
  public notificationDataObj: any;
  public notificationStatusIcon: {};
  public selection: any[] = [];   // holds selected rows
  public selectedRow: any;
  public dataSource: any[] = [];  // table rows
  public displayedColumns = ['select', 'allColumns'];
  public tableData: any[] = [];
  public selectedColumns: any;
  public StatusData: any;
  public notificationId: string;
  public notificationData: any;
  public filterOverlayData: any;
  public notificationLabel: any = '';
  public isSetCom: boolean = false;
  public isSetCancelled: boolean = false;
  public accDataObj: any;
  public showRecipientsTable: boolean = true;
  data: any;
  visibleFilterDialog: boolean;
  dropdownPosition: { top: string; right: string } = { top: '0px', right: '0px' };

  constructor(
    private _cdr: ChangeDetectorRef,
    public filterOverlay: FilterOverlayDialogService,
    public notificationSearchService: NotificationSearchService
  ) {
    this.notificationDataObj = history.state.notificationDataObj;
    this.accDataObj = history.state.customerDetails?.customerData;

    if (this.notificationDataObj) {
      this.notificationData = this.notificationDataObj.notificationData;
      this.notificationId = this.notificationData.NotificationId;
      this.contactDataObj = this.notificationDataObj.contactData;
    }
  }

  ngOnInit(): void {
    console.log("setCancelled in contact table:", this.isSetCancelled);
    this.tableData = recepientTableColumns;
    this.dataSource = this.tableData;

    // Clear session storage to use defaults (remove this line after testing if needed)
    sessionStorage.removeItem('SelectedColumns');

    const sessionColumnsData = sessionStorage.getItem('SelectedColumns');
    if (sessionColumnsData) {
      const parsedData = JSON.parse(sessionColumnsData);
      // Maintain original order from recepientTableColumns when loading from session
      if (parsedData && parsedData.length > 0) {
        this.selectedColumns = recepientTableColumns.filter(col => 
          parsedData.some((sessionCol: any) => sessionCol.key === col.key)
        );
        if (this.selectedColumns.length === 0) {
          this.selectedColumns = [...recepientTableInit];
        }
      } else {
        this.selectedColumns = [...recepientTableInit];
      }
    } else {
      // First time - use default columns
      this.selectedColumns = [...recepientTableInit];
    }

    // Initialize selection based on selectedColumns (default columns only)
    this.syncSelectionWithSelectedColumns();
  }

  // Sync selection array with selectedColumns
  private syncSelectionWithSelectedColumns(): void {
    this.selection = [];
    // Only select items that exist in selectedColumns
    this.dataSource.forEach(row => {
      const isInSelectedColumns = this.selectedColumns.some(
        (col: any) => col.key === row.key && col.value === row.value
      );
      if (!row.disabled && isInSelectedColumns) {
        this.selection.push(row);
      }
    });
    this._cdr.detectChanges();
  }

  // ✅ Selection Helpers
  public isSelected(row: any): boolean {
    return this.selection.includes(row);
  }

  public hasValue(): boolean {
    return this.selection.length > 0;
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.length;
    const numDisabled = this.dataSource.filter(row => row.disabled).length;
    const numRows = this.dataSource.length;
    return numSelected + numDisabled === numRows;
  }

  public masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection = [];
    } else {
      this.selection = [...this.dataSource.filter(row => !row.disabled)];
    }
    this._cdr.detectChanges();
  }

  public toggleSelection(row: any): void {
    if (row.disabled) return;

    const index = this.selection.indexOf(row);
    if (index === -1) {
      this.selection.push(row);
    } else {
      this.selection.splice(index, 1);
    }
  }

  // ✅ Column Selection
  public getSelectedColumns(): void {
    // Maintain original order from recepientTableColumns constant
    const orderedSelection = recepientTableColumns.filter(col => 
      this.selection.some(selected => selected.key === col.key)
    );
    
    // Force complete re-render by hiding and showing the table
    this.showRecipientsTable = false;
    this._cdr.detectChanges();
    
    setTimeout(() => {
      this.selectedColumns = orderedSelection.length > 0 
        ? [...orderedSelection.map(col => ({...col}))] 
        : [...recepientTableInit.map(col => ({...col}))];
      
      sessionStorage.setItem('SelectedColumns', JSON.stringify(this.selectedColumns));
      this.showRecipientsTable = true;
      this._cdr.detectChanges();
    }, 0);
    
    this.closeMenu();
  }

  // ✅ Restore previous selections
  public ngAfterViewInit(): void {
    // Selection is already initialized in ngOnInit
  }

  // ✅ Filter logic
  public filterData(): void {
    this.filterOverlay.filterData$.subscribe(filterValue => {
      this.filterOverlayData = filterValue;
    });

    this.data = this.filterOverlayData;
    this.visibleFilterDialog = true;
    this._cdr.detectChanges();
  }

  public onFilterDialogClosed() {
    this.visibleFilterDialog = false;
  }

  toggleMenu(event?: MouseEvent): void {
    if (!this.menuVisible && this.settingsIconRef) {
      this.updateDropdownPosition();
    }
    this.menuVisible = !this.menuVisible;
    this._cdr.detectChanges();
  }

  private updateDropdownPosition(): void {
    if (this.settingsIconRef) {
      const el = this.settingsIconRef.nativeElement;
      const rect = el.getBoundingClientRect();
      this.dropdownPosition = {
        top: `${rect.bottom + 8}px`,
        right: `${window.innerWidth - rect.right}px`
      };
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (this.menuVisible) {
      this.updateDropdownPosition();
    }
  }

  closeMenu(): void {
    this.menuVisible = false;
    this._cdr.detectChanges();
  }

  public onSearchValue(value: string): void {
  this.notificationSearchService.getSearchedData(value);
}
}